import React from 'react';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import Header from './header';
import Footer from './footer';
import StructuredData from './structured-data';
import company from '@data/company.json';
import '@styles/bootstrap-reboot.css';
import '@styles/bootstrap-nav.css';
import '@styles/bootstrap-grid.css';
import '@styles/layout.css';

const Layout = ({ children, pageTitle, pageDescription, pagePath }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
            siteUrl
          }
        }
        ogImage: file(relativePath: { eq: "hero/pumpa.jpg" }) {
          childImageSharp {
            fixed(width: 1200, quality: 80) {
              src
            }
          }
        }
      }
    `}
    render={data => {
      const title = pageTitle
        ? `${pageTitle} | ${data.site.siteMetadata.title}`
        : data.site.siteMetadata.title;
      const description = pageDescription || company.description;
      const siteUrl = data.site.siteMetadata.siteUrl.replace(/\/$/, '');
      const ogImageUrl = data.ogImage
        ? `${siteUrl}${data.ogImage.childImageSharp.fixed.src}`
        : '';

      return (
        <>
          <Helmet title={title}>
            <html lang="sr" />
            <meta name="description" content={description} />
            <meta name="viewport" content="width=device-width,initial-scale=1" />
            {pagePath != null && <link rel="canonical" href={`${siteUrl}${pagePath}`} />}

            <meta property="og:type" content="website" />
            <meta property="og:url" content={pagePath != null ? `${siteUrl}${pagePath}` : siteUrl} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            {ogImageUrl && <meta property="og:image" content={ogImageUrl} />}

            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={pagePath != null ? `${siteUrl}${pagePath}` : siteUrl} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            {ogImageUrl && <meta property="twitter:image" content={ogImageUrl} />}
          </Helmet>
          <StructuredData
            siteUrl={siteUrl}
            ogImageUrl={ogImageUrl}
            pageTitle={pageTitle}
            pagePath={pagePath}
          />
          <Header />
          <main>{children}</main>
          <Footer />
        </>
      );
    }}
  />
);

export default Layout;
